var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"mt-2"},[_c('small',{staticClass:"d-block text-muted"},[_vm._v("Before fix, the value in the DB was:")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":"","readonly":""},domProps:{"value":_vm.value}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7774ea06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhoneBeforeFix.vue
// module id = 737
// module chunks = 30